import React, { Component } from "react";

import { HashRouter, Route, Link } from 'react-router-dom';

import { Layout, Menu, Row, Col } from 'antd';

import { appName, siteInfo } from "../config";

import { withTranslation } from "react-i18next";


class Footer extends Component {


  render() {

    const { t } = this.props

    //  backgroundColor:'#2d3436'
    return (
      <>
        <div style={{ backgroundColor: 'rgba(0,0,0,0.4)', marginTop: 200, bottom: 0 }}>
          <Row style={{
            justifyContent: 'center',
            color: 'rgba(255, 255, 255,0.3)',
            padding: ' 10px 50px'
          }}>
            <div style={{

            }}>
              {`${new Date().getFullYear()} ${appName} © Tüm hakları saklıdır`}
            </div>
          </Row>
        </div>
      </>
    )
  }
}

export default withTranslation()(Footer)


